import React, { Fragment } from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";

function Input_customer_emb(props) {
  const { label, name, ...rest } = props;
  return (
    <Fragment>
      {/* <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
        <Form.Label>Email address</Form.Label>
        <Form.Control type="email" placeholder="name@example.com" autoFocus />
      </Form.Group> */}

      <div className="form-control-customed single_input_cus_emb">
        <label htmlFor={name}>{label}</label>
        <Field className="input_text_cus_emb" id={name} name={name} {...rest} />
        <ErrorMessage component={TextError} name={name} />
      </div>

      {/* <div className="form-control">
        <label htmlFor={name}>{label}</label>
        <Field id={name} name={name} {...rest} />
        <ErrorMessage component={TextError} name={name} />
      </div> */}
    </Fragment>
  );
}

export default Input_customer_emb;
